import AdsOn from "../../Components/adsOn/adsOn";

export default function AdsOnPage() {

  return (
    <>
      <AdsOn/>
    </>
  );
}
